import styled from '@emotion/styled'
import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'

import { Tag } from '@/components'
import { StayCommitment } from '@/types/User'

type Props = {
  stayCommitment: StayCommitment
}

export const MobileStayCommitment = ({ stayCommitment }: Props) => {
  const { fulfilledAt, cancelledAt, earlyTerminationFeeWaivedAt, committedNights, earlyTerminationFeeType, createdAt } =
    stayCommitment

  const isFulfilled = !!fulfilledAt
  const isCancelled = !!cancelledAt
  const earlyTerminationFeeWaived = !!earlyTerminationFeeWaivedAt

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const createdDate = createdAt ? formatInTimeZone(createdAt, timezone, 'yyyy-MM-dd') : ''

  return (
    <BoxStyled role="presentation">
      <div className="stay-commitment-information grid grid-cols-3">
        <div className="border-r border-secondary">
          <h6>Committed Nights</h6>
          <p>{committedNights}</p>
        </div>
        <div className="border-r  pl-2 border-secondary">
          <h6>Early-Termination Fee</h6>
          <p>{earlyTerminationFeeType}</p>
        </div>
        <div className="pl-2">
          <h6>Created</h6>
          <p>{createdDate}</p>
        </div>
      </div>
      <div className="mb-1 mt-1 flex items-center justify-between">
        <div className="inline-flex">
          {isFulfilled && (
            <Tag className="mr-1 rounded-full text-sm text-tag-green-dark tag-green-light">Fulfilled</Tag>
          )}
          {isCancelled && <Tag className="mr-1 rounded-full text-sm text-tag-red-dark tag-red-light">Cancelled</Tag>}
          {earlyTerminationFeeWaived && (
            <Tag className="rounded-full text-sm text-tag-purple-dark tag-purple-light">Early-Termination Waived</Tag>
          )}
        </div>
      </div>
    </BoxStyled>
  )
}

const BoxStyled = styled.div`
  padding: 0.75rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);

  .stay-commitment-information {
    div {
      display: flex;
      flex-direction: column;
    }

    h6 {
      color: #787573;
      font-size: var(--text-p-xs);
    }
    p {
      font-size: var(--text-p-xs);
      line-height: 1.8;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`
